import type {UserEvent, UserEventDetailComponentProps} from '@cohort/merchants/apps';
import {formatDetailComponentBoldText} from '@cohort/merchants/apps/cohort/utils/format';
import {getCampaignRoute} from '@cohort/merchants/lib/Pages';
import type {CohortReferralCompletedEventStruct} from '@cohort/shared/apps/cohort/userEvents/referral/referralCompleted';
import {CohortReferralCompletedEventSpec} from '@cohort/shared/apps/cohort/userEvents/referral/referralCompleted';
import {Trans} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

const DetailComponent: React.FC<UserEventDetailComponentProps> = ({userEvent}) => {
  const properties = userEvent.properties as CohortReferralCompletedEventStruct['Properties'];
  const {campaignId, campaignInternalName} = properties;
  const navigate = useNavigate();
  return (
    <Trans
      i18nKey="userEvents.referral.completed.detail"
      ns="app-cohort"
      values={{
        campaignInternalName,
      }}
      components={{
        bold: formatDetailComponentBoldText(userEvent, () => {
          if (campaignId) {
            navigate(getCampaignRoute(campaignId).path);
          }
        }),
      }}
    />
  );
};

export const CohortReferralCompletedUserEvent: UserEvent<CohortReferralCompletedEventStruct> = {
  spec: CohortReferralCompletedEventSpec,
  detailComponent: DetailComponent,
};
